import IconBox from "./IconBox";
import {useTranslation} from "react-i18next";

const TableFileBox = ({value, changeFunction, accept, reset}) => {
  const {t} = useTranslation()

  return (
    <div className="filter_box has_border">
      <label style={{margin: 0}}>
        <IconBox iconName="attachIcon" specialClass="border_shadow large_icon"/>
        <input type="file" onChange={changeFunction} accept={accept} style={{display: 'none'}}/>
      </label>
      <div className="filter_field_box">
        <input
          type="text"
          className="filter_field field_shadow"
          value={value}
          readOnly
          placeholder={t('Organizational.CustomerClub.FileName.Place.Holder')}
        />
      </div>
    </div>
  );
};

export default TableFileBox;
